import * as actionTypes from '../../actionTypes';
import createReducer from '../../../../common/utils/createReducer';

const initialState = {
  globalInfoDataAvailable: false,
  globalInfo: {
    is_downtime_active: false,
  }
};

// THis reducer will not clear it's value on logout
const reducerMap = {
  [actionTypes.GET_GLOBAL_INFO]: (state, action) => {
    return {
      ...state,
      globalInfo: action.globaInfo,
      globalInfoDataAvailable: true
    }
  }
};

const GlobalReducer = createReducer(initialState, reducerMap);
export default GlobalReducer;
